import './front.scss';
import { TeamFront } from './TeamFront.js';

document.querySelectorAll( '[data-block="team"]' ).forEach( ( element ) => {
	new TeamFront( element );
} );
